module.exports = __webpack_public_path__ + "static/media/WAF5_14Feb1983.96f9973a.jpg";